/**
 * Drag handle for moving a CSV column between entity-type sections in a
 * multi-type import. Uses @dnd-kit's useDraggable; the draggable id encodes
 * the source virtual file id and the column as `${virtualFileId}::${column}`.
 *
 * Only rendered inside multi-type sections (single-type files have one section,
 * so there is nowhere to move a column to).
 */

import { useDraggable } from '@dnd-kit/core';

import { DragHandle } from '@/lib/base/foundations';

interface ColumnDragHandleProps {
  /** `${virtualFileId}::${column}` */
  dragId: string;
  /** Column name, for the accessible label. */
  column: string;
}

export function ColumnDragHandle({ dragId, column }: ColumnDragHandleProps) {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: dragId,
  });

  return (
    <span ref={setNodeRef}>
      <DragHandle
        dragHandleProps={{ ...listeners, ...attributes }}
        label={`Drag column ${column} to another object type`}
      />
    </span>
  );
}
